<template>
  <v-layout row class="align-center layout px-4 pt-4 app--page-header" v-if="breadcrumbs && breadcrumbs.length > 0">
    <v-breadcrumbs divider="-" :items="breadcrumbs"></v-breadcrumbs>
    <v-spacer />
    <div class="page-header-right">
      <v-btn icon> <v-icon class="text--secondary">refresh</v-icon> </v-btn>
    </div>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      title: 'Home',
      breadcrumbs: [],
    }
  },
  methods: {
    computeBreadcrumbs() {
      let breadcrumbs = [
        {
          text: 'Home',
          to: { path: '/' },
          disabled: true,
        },
      ]
      if (this.$route.path !== '/dashboard') {
        if (this.$route.meta.disableCrumbs) this.breadcrumbs = []
        else {
          let appends = []
          appends = this.$route.matched.map(item => {
            const path = item.path || '/'
            let tmp = {
              text: item.meta.title || '',
              to: { path: path },
            }
            if (item.path === this.$route.path || (item.meta && item.meta.disableCrumb)) {
              tmp.disabled = true
            }
            return tmp
          })
          this.breadcrumbs = breadcrumbs.concat(appends)
        }
      }
    },
  },
  created() {
    this.computeBreadcrumbs()
  },
}
</script>
<style lang="sass" scoped>
.disabled
  color: grey
  pointer-events: none
  text-decoration: blink
</style>
